import { ref, computed } from 'vue'

export function useCourseSelection() {
  const selectedCourses = ref([])
  const parentId = ref(0)

  const hasSelectedCourses = computed(() => selectedCourses.value.length > 0)

  const addCourse = (course, parentCategories = []) => {
    // Verificar si el curso ya está seleccionado
    if (selectedCourses.value.find(c => c.id === course.id)) {
      return false
    }

    // Calcular parentId basado en las categorías del curso
    const courseCategories = course.categories || []
    let codeParentId = 0

    // Asegurar que courseCategories es un array
    const categoriesArray = Array.isArray(courseCategories) ? courseCategories : []

    for (const category of categoriesArray) {
      // Verificar si category es un objeto con id o si es un array
      if (Array.isArray(category)) {
        // Si es un array, iterar sobre sus elementos
        for (const cat of category) {
          if (cat.id && parentCategories.includes(cat.id)) {
            codeParentId = cat.id
            break
          }
        }
      } else if (category.id && parentCategories.includes(category.id)) {
        // Si es un objeto directo
        codeParentId = category.id
        break
      }
      if (codeParentId) break
    }

    parentId.value = codeParentId
    selectedCourses.value.push(course)
    return true
  }

  const removeCourse = (course) => {
    const index = selectedCourses.value.findIndex(c => c.id === course.id)
    if (index !== -1) {
      selectedCourses.value.splice(index, 1)
      return true
    }
    return false
  }

  const clearSelection = () => {
    selectedCourses.value = []
    parentId.value = 0
  }

  const initializeFromLocalStorage = () => {
    const storedCourses = localStorage.getItem('cursoDefecto')
    if (!storedCourses) return

    try {
      const courses = JSON.parse(storedCourses)
      const coursesArray = Array.isArray(courses) ? courses.reverse() : [courses]
      
      selectedCourses.value = coursesArray.map(course => ({
        id: course.item || course.id,
        name: course.name,
        image: course.image,
        slug: course.slug
      }))

      localStorage.removeItem('cursoDefecto')
    } catch (error) {
      console.error('Error parsing stored courses:', error)
      localStorage.removeItem('cursoDefecto')
    }
  }

  return {
    selectedCourses,
    parentId,
    hasSelectedCourses,
    addCourse,
    removeCourse,
    clearSelection,
    initializeFromLocalStorage
  }
}